import React from "react"
import SibaBreadcrumb from "../components/common/SibaBreadcrumb";
import * as Constants from '../utils/constants'
import SibaTitoloPagina from "../components/common/SibaTitoloPagina";
import { showProtectedResources, showUnprotectedResources } from "../utils/elements";
import {
  Container
} from 'design-react-kit';

export const SibaEsitoPagamentoMain = ({ ok, authMode }) => {

  const showLinks = () => {
    switch (authMode) {
      case Constants.AUTH_MODE_PUBLIC:
        return showUnprotectedResources();
      case Constants.AUTH_MODE_PROTECTED:
        return showProtectedResources();
      default:
        return React.Fragment;
    }
  }

  // START RENDERING
  return (
    <main>
      <SibaBreadcrumb pageName={Constants.STR_ESITO_OPERAZIONE_TITOLO} />
      <SibaTitoloPagina titolo={Constants.STR_ESITO_OPERAZIONE_TITOLO} />
      <Container className="px-2 my-2" id="esitoPagamento" tag="section">
        <h3>Pagamento bollo auto {ok ? 'Completato!' : 'non effettuato!'}</h3>
        <br />
        <h4>{ok ? 'La ricevuta di pagamento verrà inviata direttamente da PagoPA' : ''}</h4>
        <br />
        {showLinks()}
      </Container>
    </main>
  )
}

export default SibaEsitoPagamentoMain;